import React, { useEffect, useState } from 'react';
import axios from 'axios';
import "./style/Order.css"
import Footer from './footer';

export default function Orders() {
    const [allorder, setallOrder] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const res = await axios.get(
                "https://mkbackend-production.up.railway.app/myOrders",
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.data.success) {
                setallOrder(res.data.orders);
            } else {
                setError(res.data.message);
            }
        } catch (error) {
            console.log(error);
            setError(error.response?.data?.message || "Failed to fetch orders");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const DeleteOrder = async (orderId) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.delete(
                `https://mkbackend-production.up.railway.app/myOrders/${orderId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            setallOrder(allorder.filter(order => order._id !== orderId));
        } catch (error) {
            console.error(error);
            alert('Failed to delete order');
        }
    }

    const UpdateStatus = async (orderId, newStatus) => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.put(
                `https://mkbackend-production.up.railway.app/myOrders/${orderId}/status`,
                { status: newStatus },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.data.success) {
                setallOrder(allorder.map(order =>
                    order._id === orderId ? { ...order, status: newStatus } : order
                ));
                alert(`✅ Order status updated to ${newStatus}`);
            }
        } catch (error) {
            console.error(error);
            alert(error.response?.data?.message || 'Failed to update status');
        }
    }

    // Which status buttons to show, based on the order's current status
    const getNextActions = (status) => {
        switch (status) {
            case 'pending':
                return [
                    { label: '✅ Accept', value: 'accepted' },
                    { label: '❌ Cancel', value: 'cancelled' }
                ];
            case 'accepted':
                return [
                    { label: '👨‍🍳 Preparing', value: 'preparing' },
                    { label: '❌ Cancel', value: 'cancelled' }
                ];
            case 'preparing':
                return [
                    { label: '🚚 On the way', value: 'on_the_way' },
                    { label: '❌ Cancel', value: 'cancelled' }
                ];
            case 'on_the_way':
                return [
                    { label: '📦 Delivered', value: 'delivered' }
                ];
            default:
                return [];
        }
    }

    const getStatusBadge = (status) => {
        const statusMap = {
            'pending': { label: '🕒 Pending', class: 'status-pending' },
            'accepted': { label: '✅ Accepted', class: 'status-accepted' },
            'preparing': { label: '👨‍🍳 Preparing', class: 'status-preparing' },
            'on_the_way': { label: '🚚 On the way', class: 'status-on-the-way' },
            'delivered': { label: '📦 Delivered', class: 'status-delivered' },
            'cancelled': { label: '❌ Cancelled', class: 'status-cancelled' }
        };
        return statusMap[status] || statusMap['pending'];
    }

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p className="loading-text">Loading your orders...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-container">
                <div className="error-box">
                    <span className="error-icon">😕</span>
                    <h2>Oops! Something went wrong</h2>
                    <p>{error}</p>
                    <button onClick={() => window.location.reload()}>
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="orders-container">
            <h1 className="orders-title">📋 My Orders</h1>
            
            {allorder.length === 0 ? (
                <div className="empty-container">
                    <span className="empty-icon">🛒</span>
                    <h2>No Orders Yet</h2>
                    <p>Start shopping to see your orders here!</p>
                </div>
            ) : (
                <div className="orders-grid">
                    {allorder.map((order, index) => (
                        <div key={order._id || index} className="order-card">
                            <div className="order-header">
                                <span className="order-number">Order #{index + 1}</span>
                                <span className={`order-status ${getStatusBadge(order.status || 'pending').class}`}>
                                    {getStatusBadge(order.status || 'pending').label}
                                </span>
                            </div>

                            {/* Customer Details */}
                            <div className="customer-details">
                                <p><strong>👤 {order.customerName}</strong></p>
                                <p>📧 {order.customerEmail}</p>
                                <p>📞 {order.customerPhone}</p>
                                <p>📍 {order.shippingAddress}</p>
                                {order.city && <p>🏙️ {order.city}</p>}
                            </div>
                            
                            <div className="order-id" style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', alignItems: 'center', padding: '10px 0' }}>
                                <button 
                                    onClick={() => DeleteOrder(order._id)} 
                                    style={{
                                        background: 'red',
                                        border: 'none',
                                        padding: '6px 12px',
                                        color: 'white',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    🗑️ Delete
                                </button>

                                {getNextActions(order.status || 'pending').map((action) => (
                                    <button
                                        key={action.value}
                                        onClick={() => UpdateStatus(order._id, action.value)}
                                        style={{
                                            background: action.value === 'cancelled' ? '#e74c3c' : '#2ecc71',
                                            border: 'none',
                                            padding: '6px 12px',
                                            color: 'white',
                                            borderRadius: '4px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {action.label}
                                    </button>
                                ))}
                            </div>
                            
                            <div className="products-list">
                                <h4>Products:</h4>
                                {order.products && order.products.length > 0 ? (
                                    order.products.map((item, i) => (
                                        <div key={item.productId?._id || i} className="product-item">
                                            <div className="product-name">
                                                {item.productId?.name || 'Product not found'}
                                            </div>
                                            <div className="product-details">
                                                <span className="product-price">
                                                    Rs: {item.productId?.price || 'N/A'}
                                                </span>
                                                <span className="product-quantity">
                                                    × {item.quantity}
                                                </span>
                                                <span className="product-total">
                                                    Rs: {(item.productId?.price * item.quantity) || 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p style={{ color: 'rgba(255,255,255,0.6)' }}>
                                        No products in this order
                                    </p>
                                )}
                            </div>
                            
                            <div className="order-footer">
                                <span className="order-date">
                                    {new Date(order.createdAt).toLocaleDateString('en-US', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })}
                                </span>
                                <span className="order-total">
                                    Total: Rs: {order.totalAmount || 
                                        order.products?.reduce((sum, item) => 
                                            sum + (item.productId?.price * item.quantity || 0), 0
                                        ).toFixed(2) || '0.00'}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <Footer />
        </div>
    );
}